import React, { Component } from "react";
import {
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle
  // CardSubtitle,
  // Button
} from "reactstrap";
import "./Card.css";

// import Icon from "../../images/medal.png";

export default class componentName extends Component {
  renderContent(content) {
    if (content === undefined) return;
    // if (content.toString.indexOf("<br>") !== 0) {
    if (content.length > 70) {
      return (
        <CardText key="long">{content.substring(0, 71) + "..."} </CardText>
      );
    }
    return content.split("<br>").map((item, i) => {
      return (
        // <div>
        <CardText key={i.toString()}>{item}</CardText>
        // </div>
      );
    });
    // } else return content;
  }
  render() {
    return (
      <div
        className="card"
        style={{
          margin: this.props.margin,
          width: this.props.width,
          verticalAlign: "top"
        }}
      >
        {/* <Link to={"/Port/:" + this.props.title}> */}
        <Card>
          <div className="CardImage">
            <CardImg
              top
              width="100%"
              height={this.props.width}
              src={this.props.src}
              alt="Card image cap"
              style={{ margin: "auto" }}
            />
          </div>
          <CardBody style={{ maxHeight: "150px" }}>
            <CardTitle className="cardtitle">{this.props.title}</CardTitle>
            <div className="cardtext">
              {this.renderContent(this.props.content)}
            </div>
          </CardBody>
        </Card>
        {/* </Link> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Card/Card.js